export default (chartId, chartsData) => {
  let chartData = [];

  try {
    if (chartsData) {
      const chart = chartsData.find((c) => chartId === c.id);

      if (chart) {
        chartData = chart.data;
      }
    }
  } catch (error) {
    console.error(error);
  }

  return chartData;
};
